// Sample favorite games data
// You can replace these with your actual favorite games and their corresponding icons
export const favoriteGames = [
  {
    id: 1,
    name: 'Minecraft',
    icon: './assets/icons/games/minecraft_icon.png',
  },
  {
    id: 2,
    name: 'Dead By Daylight',
    icon: './assets/icons/games/dbd.png',
  },
  {
    id: 3,
    name: 'The Legend of Zelda',
    icon: './assets/icons/games/zelda_icon copy.png',
  },
  {
    id: 4,
    name: 'Elden Ring',
    icon: './assets/icons/games/elden.png',
  },
  {
    id: 5,
    name: 'Stardew Valley',
    icon: './assets/icons/games/stardew_icon.png',
  },
];
